var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"text-left",attrs:{"header-bg-variant":"info","header-text-variant":"white"}},[_c('listar-citas')],1)}
var staticRenderFns = []

export { render, staticRenderFns }